import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GenericResponse } from '../../_models/response.model';
import { GetPspSubscriptionStatusTrackingResponse } from '../../_models/PSP/psp-subscription-status-tracking.model';

@Injectable({
  providedIn: 'root'
})
export class PspSubscriptionStatusTrackingService {

  constructor(private http: HttpClient) {}

  getStatusChangeTracking(subscriptionId: number): Observable<GenericResponse<any>> {
    return this.http.get<GenericResponse<GetPspSubscriptionStatusTrackingResponse>>(this.getBaseUrl(subscriptionId));
  }

  private getBaseUrl(subscriptionId: number): string {
    return `api/PspSubscriptions/${subscriptionId}/StatusTracking`;
  }
}
